import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from 'store';

import ParamsService from 'services/ParamsService';

import { AttentionClassToUpdate, AttentionClassType, AttentionClassValue, AttentionClassesProps } from 'types/attentionClasses';
import { ParamToUpdate, ParamValue, ParamsType } from 'types/params';
import AttentionClassesService from 'services/AttentionClassesService';
import LogAction from 'models/enums/LogAction';

// initial state
const initialState: AttentionClassesProps = {
    isEditing: false,
    isLoading: false,
    newAttentionClasses: []
};

// ==============================|| SLICE - ATTENTION CLASSES ||============================== //

const attentionClasses = createSlice({
    name: 'attentionClasses',
    initialState,
    reducers: {
        initilizeEdit(state, action) {
            state.isEditing = action.payload;
        },
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        changeParamValue(state, action) {
            state.newAttentionClasses = action.payload;
        },
        reset(state) {
            state.isEditing = false;
            state.newAttentionClasses = [];
        }
    }
});

export default attentionClasses.reducer;

const attentionClassesService = new AttentionClassesService();

export const onAttentionClassesEdit = (state: boolean) => dispatch(attentionClasses.actions.initilizeEdit(state));
export const resetAttentionClasses = () => dispatch(attentionClasses.actions.reset());

export const onChangeAttentionClassValue = (
    attentionClass: AttentionClassType,
    id: string,
    min: number | null,
    max: number | null,
    attentionClassesToUpdate: AttentionClassToUpdate[]
) => {
    let newAttentionClasses: AttentionClassToUpdate[] = [];
    const newValue: AttentionClassValue = { id, min, max };

    const attentionClassIndex = attentionClassesToUpdate.findIndex((p) => p.attentionClass === attentionClass);

    // Se il parametro esiste nell'array paramsToUpdate
    if (attentionClassIndex > -1) {
        const valueIndex = attentionClassesToUpdate[attentionClassIndex].values.findIndex((p) => p.id === id);

        // Se il valore esiste già all'interno dei valori del parametro
        if (valueIndex > -1) {
            newAttentionClasses = attentionClassesToUpdate.map((p) => {
                if (p.attentionClass === attentionClass) {
                    // Copia tutti i valori del parametro e aggiorna solo il valore specifico
                    const newValues = p.values.map((p) => {
                        if (p.id === id) return { ...p, min, max };
                        return p;
                    });
                    return { ...p, values: newValues };
                }
                return p;
            });
        } else {
            // Se il valore non esiste ancora, aggiungi il nuovo valore ai valori del parametro corrente
            const newValues = [...attentionClassesToUpdate[attentionClassIndex].values, newValue];
            newAttentionClasses = attentionClassesToUpdate.map((p) => {
                if (p.attentionClass === attentionClass) {
                    return { ...p, values: newValues };
                }
                return p;
            });
        }
    } else {
        // Se il parametro non esiste, aggiungi un nuovo parametro con il valore
        newAttentionClasses = [...attentionClassesToUpdate, { attentionClass: attentionClass, values: [newValue] }];
    }

    dispatch(attentionClasses.actions.changeParamValue(newAttentionClasses));
};

export const onSaveAttentionClasses = async (
    tenantId: string,
    userId: string,
    username: string,
    simulationId: string | null,
    attentionClassesToUpdate: AttentionClassToUpdate[]
) => {
    try {
        dispatch(attentionClasses.actions.setIsLoading(true));
        const res = await attentionClassesService.updateAttentionClasses({
            tenantId,
            userId,
            username,
            action: LogAction.EDIT,
            simulazioneId: simulationId,
            attentionClasses: attentionClassesToUpdate
        });
        dispatch(attentionClasses.actions.setIsLoading(false));
        return res;
    } catch (error) {
        dispatch(attentionClasses.actions.setIsLoading(false));
        return false;
    }
};
